import * as React from 'react';

import ReactMarkdown from 'react-markdown';

import { Text } from '@components/common';

interface MarkdownProps {
  content: string;
}

export const Markdown: React.FC<MarkdownProps> = ({ content }) => (
  <div className='text-sm'>
    <ReactMarkdown
      components={{
        h1: ({ children }) => (
          <Text h='700' mt='3' mb='6'>
            {children}
          </Text>
        ),
        h2: ({ children }) => (
          <Text h='600' mt='2' mb='4'>
            {children}
          </Text>
        ),
        h3: ({ children }) => (
          <Text h='500' mt='1' mb='2'>
            {children}
          </Text>
        ),
        ul: ({ children }) => <ul className='list-disc space-y-1 pl-6'>{children}</ul>,
        ol: ({ children }) => <ol className='list-decimal space-y-1 pl-6'>{children}</ol>,
        li: ({ children }) => <li className='leading-relaxed'>{children}</li>,
        p: ({ children }) => <p className='mb-2'>{children}</p>
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);
